module.exports = __webpack_public_path__ + "img/helicoverpa-armigera.2ddacddb.jpg";